import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';
import { FlexibleDiv } from '../../../../styled/common';
import { StatusType } from './types';

export const MessageStatusContainer = styled(FlexibleDiv)`
  width: 100%;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 40px;
    margin-top: 15px;
    gap: 5px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 0;
    margin-top: 0;
  }
`;

const defaultBackground = css`
  background-color: #bcbcbc;
`;

const backgroundColors = {
  [StatusType.Expired]: defaultBackground,
  [StatusType.ExpiredSell]: defaultBackground,
  [StatusType.ExpiredLease]: defaultBackground,
  [StatusType.Pending]: css`
    background-color: ${({ theme }) => theme.colors.systemColors.yellow};
  `,
  [StatusType.Limited]: defaultBackground,
  [StatusType.Rejected]: css`
    background-color: ${({ theme }) => theme.colors.systemColors.red};
  `,
  [StatusType.None]: defaultBackground
};

export const MessageDivider = styled.div<{ $status: StatusType }>`
  width: 5px;
  border-radius: 10px;
  display: none;

  ${({ $status }) => backgroundColors[$status]}

  @media (min-width: ${Breakpoints.tablet}px) {
    display: block;
  }
`;

export const StatusBox = styled.div<{ $status: StatusType }>`
  padding: 15px;
  width: 100%;

  ${({ $status }) => backgroundColors[$status]}

  @media (min-width: ${Breakpoints.tablet}px) {
    border-radius: 7px;
  }
`;

export const MessageStatusText = styled(Typography)<{ $asBlock?: boolean }>`
  color: ${({ theme }) => theme.colors.text.white};

  ${({ $asBlock }) =>
    $asBlock &&
    css`
      display: block;
    `}
`;
